import './Header.css';
import seta from './img/setaBotao.png'
import logotipo from './img/LogotipoSofie.png'
import homem from './img/HomemVendoCelular.png'
import logoSofie from './img/LogoSofie.png'
// import menuMobile from './img/MenuMobile.png'
// import { useState } from 'react';


function Header() {
    // const [modal, setModal] = useState(false);
  return (
    <div className="headerContainer">
        {window.innerWidth > 800 &&
        <>
            <div className="primeiraBola">
                <svg width="683" height="324" viewBox="0 0 683 324" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M125.67 -3C157.987 120.709 270.501 212 404.337 212C538.173 212 650.687 120.709 683.005 -3H125.67Z" fill="#EB5757"/>
                    <path d="M403.837 324C204.981 324 38.9889 183.287 0 -4H807.675C807.013 -0.81975 806.314 2.34707 805.579 5.5C763.039 188.026 599.317 324 403.837 324Z" fill="#80C8D5" fill-opacity="0.149"/>
                </svg>
            </div>
            <div className="segundaBola">
                <svg width="473" height="720" viewBox="0 0 473 720" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="-1" y="85" width="348" height="502">
                        <rect x="-1" y="85.7955" width="347.43" height="500.333" fill="#C4C4C4"/>
                    </mask>
                    <g mask="url(#mask0)">
                        <path d="M346.43 330.441C346.43 465.554 236.899 575.086 101.785 575.086C-33.3289 575.086 -142.86 465.554 -142.86 330.441C-142.86 229.563 -81.8036 142.945 5.37095 105.527C34.956 92.8278 67.5492 85.7955 101.785 85.7955C236.899 85.7955 346.43 195.327 346.43 330.441Z" fill="#EB5757"/>
                    </g>
                    <mask id="mask1" mask-type="alpha" maskUnits="userSpaceOnUse" x="-1" y="0" width="474" height="720">
                        <rect x="-1" width="474" height="719.495" fill="#C4C4C4"/>
                    </mask>
                    <g mask="url(#mask1)">
                        <path d="M454.312 350.403C454.312 543.926 297.431 700.806 103.909 700.806C-89.6138 700.806 -246.495 543.926 -246.495 350.403C-246.495 156.881 -89.6138 0 103.909 0C297.431 0 454.312 156.881 454.312 350.403Z" fill="#80C8D5" fill-opacity="0.14902"/>
                    </g>
                </svg>
            </div>
        </>
        }

        {window.innerWidth > 800
        ?
        <div className="headerTop">
            <div className="headerTopItem" onClick={() => {window.location.href = ""}}>
                Início
            </div>
            <div className="headerTopItem" onClick={() => {window.location.href = "#ComoFunciona"}}>
                Como Funciona
            </div>
            <div className="headerTopItem" onClick={() => {window.location.href = "#BaixarApp"}}>
                Para ser um Sofier
            </div>
        </div>
        :
        <div className="headerTopMobile">
            <div>
                <img src={logoSofie} alt="seta" />
            </div>
            {/* <div className="headerTopMobileMenu">
                <img src={menuMobile} alt="seta" onClick={() => setModal(!modal)} />
                {modal &&
                <div className="headerTopMobileMenuContent">
                    <div className="headerTopMobileMenuItem" onClick={() => {window.location.href = "#ComoFunciona"; setModal(!modal)}}>
                        Como Funciona
                    </div>
                    <div className="headerTopMobileMenuLine" />
                    <div className="headerTopMobileMenuItem" onClick={() => {window.location.href = "#BaixarApp"; setModal(!modal)}}>
                        Para ser um Sofier
                    </div>
                </div>
                }
            </div> */}
        </div>
        }
        <div className="headerBottom">
            {window.innerWidth > 800 &&
            <div className="headerLeft">
                <div className="headerLeftImage left">
                    <img src={logotipo} alt="logotipo" />
                </div>
                <div className="headerLeftImage right">
                    <img src={homem} alt="homem" />
                </div>
            </div>
            }
            <div className="headerRight">
                <div className="headerRightText">
                    Com a <div className="inline red">Sofie</div> você transforma seu tempo em dinheiro.
                </div>
                <div className="headerRightText">
                    Com <b>desafios simples</b> você aproveita seu tempo para fazer uma <div className="inline green">renda extra</div>.
                </div>
                <div className="headerRightButton" onClick={() => {window.location.href = "#Cadastrar"}}>
                    <div className="headerRightButtonText">
                        Cadastre-se aqui
                    </div>
                    <div className="headerRightButtonIcon">
                        <img src={seta} alt="seta" />
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Header;
